import React from "react";
import { Form } from "antd";
import CheckboxGroupWithCheckAll from "./CheckboxGroupWithCheckAll";

function WidgetClsCode({ options, iconCodeByClsCode }) {
  return (
    <Form.Item>
      <CheckboxGroupWithCheckAll
        title="무선국종"
        fieldName={"cls_code_list"}
        options={options.map(({ cls_code, label }) => ({
          value: cls_code,
          label,
          iconCode: iconCodeByClsCode[cls_code],
          //iconCode: !(cls_code==81) ? iconCodeByClsCode[cls_code] : iconCodeByClsCode[21],
        }))}
        colSpan={12}
      />
    </Form.Item>
  );
}

export default WidgetClsCode;
